import React from "react";

export default function QueryTile(props) {
  if (!props.queries) return null;

  return props.queries.map((q) => <div>{q.name}</div>);
}
